document.addEventListener('DOMContentLoaded', function () {

  // Preloader
  var loader = document.getElementById('hn-loader');
  if (loader) {
    setTimeout(function () {
      loader.classList.add('is-hidden');
      setTimeout(function () { loader.remove(); }, 900);
    }, 1500);
  }

  // Nav scroll state
  var nav = document.getElementById('hn-nav');
  window.addEventListener('scroll', function () {
    if (!nav) return;
    if (window.scrollY > 40) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  }, { passive: true });

  // Burger menu
  var burger = document.getElementById('hn-burger');
  var mob = document.getElementById('hn-nav-mobile');
  if (burger && mob) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      mob.hidden = open;
    });
    mob.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.setAttribute('aria-expanded', 'false');
        mob.hidden = true;
      });
    });
  }

  // Reveal on scroll
  var reveals = document.querySelectorAll('.hn-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '-80px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Portfolio filter
  var filters = document.getElementById('hn-filters');
  var masonry = document.getElementById('hn-masonry');
  if (filters && masonry) {
    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-filter]');
      if (!btn) return;
      filters.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var f = btn.dataset.filter;
      masonry.querySelectorAll('.hn-tile').forEach(function (t) {
        t.hidden = !(f === 'Alle' || t.dataset.cat === f);
      });
    });
  }

  // Lightbox
  var lb = document.getElementById('hn-lightbox');
  var lbImg = document.getElementById('hn-lightbox-img');
  var lbClose = document.getElementById('hn-lightbox-close');
  document.querySelectorAll('.hn-tile').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!lb || !lbImg) return;
      lbImg.src = t.dataset.src;
      lb.hidden = false;
    });
  });
  function closeLb() { if (lb) { lb.hidden = true; lbImg.src = ''; } }
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  if (lbClose) lbClose.addEventListener('click', closeLb);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });

  // Testimonials rotator
  var tt = document.getElementById('hn-tt');
  var dots = document.getElementById('hn-tt-dots');
  if (tt && dots) {
    var items = tt.querySelectorAll('.hn-tt__item');
    var idx = 0;
    items.forEach(function (_, i) {
      var b = document.createElement('button');
      b.setAttribute('aria-label', 'Stimme ' + (i + 1));
      if (i === 0) b.classList.add('is-active');
      b.addEventListener('click', function () { go(i); });
      dots.appendChild(b);
    });
    function go(n) {
      items[idx].classList.remove('is-active');
      dots.children[idx].classList.remove('is-active');
      idx = n;
      items[idx].classList.add('is-active');
      dots.children[idx].classList.add('is-active');
    }
    if (items.length > 1) {
      setInterval(function () { go((idx + 1) % items.length); }, 7000);
    }
  }

  // FAQ accordion
  document.querySelectorAll('.hn-faq__item').forEach(function (item) {
    var q = item.querySelector('.hn-faq__q');
    var a = item.querySelector('.hn-faq__a');
    function set(open) {
      if (open) { item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      else { item.classList.remove('is-open'); a.style.maxHeight = '0px'; }
    }
    set(item.classList.contains('is-open'));
    q.addEventListener('click', function () { set(!item.classList.contains('is-open')); });
  });

});